import React, {useEffect, useState} from 'react';
import {loadStripe} from '@stripe/stripe-js';
import {Elements} from '@stripe/react-stripe-js';
import {CardForm} from './CardForm';

const DEMO_PUBLISHABLE_KEY =
  'pk_test_51K1yvAK258Vuxm4DefLCmuJHyQole8qXDOAXoeOFlGAvvGeFwYlkeMutePA37wn4qcO7io15Zrs0KjD1m5qZiVtN00v35dmhXA';

export const CardDemo = () => {
  const [promise, setPromise] = useState(null);

  useEffect(() => {
    setPromise(loadStripe(DEMO_PUBLISHABLE_KEY));
  }, []);

  if (!promise) {
    return null;
  }
  return (
    <Elements stripe={promise}>
      <CardForm />
    </Elements>
  );
};
